import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Shuush - perfect tool for all my twitter followers",
  "description": "",
  "published": "2011-11-30T00:00:00.000Z",
  "redirect_from": ["/blog/shuush-perfect-tool-for-all-my-twitter-followers/swizec/3088"],
  "categories": "Business, Online Communities, Social network, Startups, Trending and Popularity, Twitter",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/11/Screen-Shot-2011-11-30-at-8.18.15-PM-300x246.png",
        "alt": "Shuush turned on",
        "title": "Shuush turned on"
      }}></img></p>
    <p>{`Ever since I started using twitter people have been accusing me that I talk too much. In the early days pretty much everyone told me this whenever we would meet in person, as more and more slovenians poured onto twitter and the whole thing has become a bit more mainstream it's not that big a problem anymore.`}</p>
    <p>{`But, still, if you follow less than about 200 people ... let's just say I have been known to fill an entire screen for such people when I really start talking. You will also notice that I tweet most of my blogposts three times.`}</p>
    <p>{`To be fair it's not actually that bad, you're just not following enough people. On my twitter I only come up every fifty tweets or even less frequently. Most of my followers wouldn't even notice a single of my blogpost tweets!`}</p>
    <p>{`Fear not! Dear twitter people of the world, if you find me annoying and because there are some even more annoying people - there is now a new experimental twitter client that you can use!`}</p>
    <p>{`Enter `}<a parentName="p" {...{
        "href": "http://shuu.sh/"
      }}>{`Shuush`}</a>{`, stage left.`}</p>
    <p>{`The idea is very simple, assign a spaminess score to people and display tweets so that font size is inversely proportional to the spaminess score. Brilliant. Elegant. Genius.`}</p>
    <p>{`Here are some screenshots, but you should really try it out yourself.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/11/Screen-Shot-2011-11-30-at-8.16.59-PM.png",
        "alt": "Shuush turned off",
        "title": "Shuush turned off"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/11/Screen-Shot-2011-11-30-at-8.18.15-PM.png",
        "alt": "Shuush turned on",
        "title": "Shuush turned on"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/11/Screen-Shot-2011-11-30-at-8.20.14-PM.png",
        "alt": "Mousing over a tweet shows the user's score",
        "title": "Mousing over a tweet shows the user's score"
      }}></img></p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://thenextweb.com/socialmedia/2011/09/08/shuush-silences-the-tweet-happy-and-lets-infrequent-tweeters-shine/"
        }}>{`Shuush silences the tweet-happy and lets infrequent tweeters shine`}</a>{` (thenextweb.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.twitterrati.com/2011/07/14/app-of-the-day-shuu-sh/"
        }}>{`App of the Day: Shuu.sh`}</a>{` (twitterrati.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://thenextweb.com/twitter/2011/07/11/is-the-new-shuu-sh-app-the-algorithm-twitter-always-needed/"
        }}>{`Is the new Shuu.sh app the algorithm Twitter always needed?`}</a>{` (thenextweb.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.psfk.com/2011/07/what-do-percolate-and-shuu-sh-indicate-about-the-future-of-social-media.html"
        }}>{`The Next Era Of Online Content Filtering: Percolate and Shuu.sh`}</a>{` (psfk.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.textually.org/textually/archives/2011/07/028935.htm"
        }}>{`Shuu.sh Solves Twitter's Biggest Problem`}</a>{` (textually.org)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.bloggingtips.com/2011/07/17/block-out-noisy-twitter-users-focus-quiet-ones-shuush/"
        }}>{`Block Out Noisy Twitter Users and Focus on the Quiet Ones with Shuush`}</a>{` (bloggingtips.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=0bd19d12-d165-46fb-b9b5-81272958503e",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      